import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { ImpactAssessmentT5, ImpactAssessmentT5DetailListModel, ImpactAssessmentT5DetailsDD, ImpactAssessmentT5DropDownList, RagRating, UpdateImpactAssessmentT5Model } from 'src/app/core/models/impact-assessment/impact-assessmentT5';
import { JurisdictionsList } from 'src/app/core/models/impact-assessment/jurisdictions-list-model';
import { LinkedIdModel } from 'src/app/core/models/impact-assessment/linked-id-model';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { UserProfile } from 'src/app/core/models/user';
import { UserDetailModel } from 'src/app/core/models/user-management/user-filter-model';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { GDPRService } from 'src/app/core/services/rulebook';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { MasterHelper } from 'src/app/core/utilities';

@Component({
  selector: 'app-bulk-update-dialog-t5',
  templateUrl: './bulk-update-dialog-t5.component.html',
  styleUrls: ['./bulk-update-dialog-t5.component.scss']
})
export class BulkUpdateDialogT5Component {
  isAuthorised = true;
  isLoading = false;
  toastModel: ToastViewModel;
  isToastShow = false;
  selectable = true;
  removable = true;
  searchStr = '';
  addOnBlur = true;
  isSavedPermission = false;
  userJurisdiction: Array<FilterViewModel>;
  libraryMenu: Array<MenuItemModel>;
  currentUserRole = '';
  linkedAssessmentIds: Array<LinkedIdModel>;
  currentinfoId: number = 0;
  jurisdictions!: JurisdictionsList;
  searchedJurisdiction!: any[];
  isLoadingDD = false;
  isSaved = false;
  alertDialogModel: AlertDialogModel;
  isParentIdEdit = false;
  parentId = 0;
  isADetailPermission = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  ragRating: RagRating[];
  detailInput: string = "";
  engagementPlanInput: string = "";
  internalStakeholders: string = "";
  externalStakeholder: string = "";
  responseKeyInput: string = "";
  policyReformInput: string = "";


  @Input()
  filterType!: string;
  @Input()
  impactAssessmentId!: number;
  filterScreenType = '';

  impactAssessment: ImpactAssessmentT5;
  iaDetailHistory: ImpactAssessmentT5DetailListModel;
  userAccessToken: UserProfile;
  impactAssessmentDD: ImpactAssessmentT5DetailsDD;
  updateIADetails: UpdateImpactAssessmentT5Model;

  responseLeadDD: string[] = [];
  accountableExecutiveDD: string[] = [];
  ruleTopicDD: string[] = [];

  @ViewChild('responseLeadAutocomplete')
  responseLeadAutocomplete!: MatAutocomplete;
  @ViewChild('responseLeadInput')
  responseLeadInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoResponseLead')
  trigautoResponseLead!: MatAutocompleteTrigger;
  searchResponseLeadCntrl: FormControl = new FormControl();
  searchedResponseLead: FilterViewModel[] = [];
  allSearchedResponseLead: FilterViewModel[] = [];

  @ViewChild('accountableExecutiveAutocomplete')
  accountableExecutiveAutocomplete!: MatAutocomplete;
  @ViewChild('accountableExecutiveInput')
  accountableExecutiveInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoAccountableExecutive')
  trigautoAccountableExecutive!: MatAutocompleteTrigger;
  searchAccountableExecutiveCntrl: FormControl = new FormControl();
  searchedAccountableExecutive: FilterViewModel[] = [];
  allSearchedAccountableExecutive: FilterViewModel[] = [];

  @ViewChild('topicAutocomplete')
  topicAutocomplete!: MatAutocomplete;
  @ViewChild('topicInput')
  topicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoTopicExecutive')
  trigautoTopicExecutive!: MatAutocompleteTrigger;
  searchTopicCntrl: FormControl = new FormControl();
  searchedTopic: FilterViewModel[] = [];
  allSearchedTopic: FilterViewModel[] = [];

  //Dropdowns
  team: Array<string> = [];
  currentStatus: Array<string> = [];
  consultationPeriod: Array<string> = [];
  responseApproach: Array<string> = [];
  engagementPlan: Array<string> = [];
  policyResponseAchieved: Array<string> = [];
  ruleType: Array<string> = [];

  constructor(private ref: ChangeDetectorRef, private gdprService: GDPRService,
    public dialog: MatDialog, public router: Router,
    private sessionService: SessionService,
    public sanitizer: DomSanitizer, private impactService: ImpactService,
    private userService: UserManagementService,
    public dialogRef: MatDialogRef<BulkUpdateDialogT5Component>,) {
    this.toastModel = new ToastViewModel();
    this.impactAssessment = new ImpactAssessmentT5();
    this.iaDetailHistory = new ImpactAssessmentT5DetailListModel();
    this.userAccessToken = new UserProfile();
    this.impactAssessmentDD = new ImpactAssessmentT5DetailsDD();
    this.userJurisdiction = [];
    this.libraryMenu = [];
    this.linkedAssessmentIds = [];
    this.updateIADetails = new UpdateImpactAssessmentT5Model();
    this.alertDialogModel = new AlertDialogModel();
    this.ragRating = [];
  }
  ngOnInit(): void {
    this.filterScreenType = this.filterType;
    this.getUserProfile();
    const selectedDivision = localStorage.getItem("selectedDivisionName")?localStorage.getItem("selectedDivisionName"):"";
    this.getImpactAssesmentDropdownList(selectedDivision!)
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
      this.userAccessToken = result;
      if (this.userAccessToken) {
        this.fetchUserDetails();
      }
    });
  }

  fetchUserDetails(): void {
    this.userService.getUserDetails().subscribe((result: UserDetailModel) => {
      this.userJurisdiction = result.userJurisdiction;
      this.libraryMenu = result.libraryMenu;
      this.currentUserRole = result && result.role.title ? result.role.title : '';
      // this.fetchImpactAssessmentDetails();
      // if (this.filterType !== 'version') {
      //   this.fetchIADetailsHistory();
      // }
       this.fetchJurisdiction();
       this.fetchImpactAssessmentDD();
    });
  }
  fetchJurisdiction(): void {
    this.impactService.GetJurisdictionsList().subscribe((result: JurisdictionsList) => {
      this.jurisdictions = result;

      this.searchedJurisdiction = this.jurisdictions.jurisdictions;
      
    })
  }
  fetchImpactAssessmentDD(): void {
    this.isLoadingDD = true;
    this.impactService.getImpactAssessmentT5DD().subscribe((result: ImpactAssessmentT5DetailsDD) => {
      this.isLoadingDD = false;
      this.impactAssessmentDD = result;
      this.ddListData();
      //this.selectedDDvalue();
    });
  }

  // selectedDDvalue(): void {
  //   this.responseLeadDD = this.impactAssessment.responseLead ? this.impactAssessment.responseLead.split(',') : this.responseLeadDD;
  //   this.accountableExecutiveDD = this.impactAssessment.accountableExecutive ? this.impactAssessment.accountableExecutive.split(',') : this.accountableExecutiveDD;
  //   this.ruleTopicDD = this.impactAssessment.ruleTopic ? this.impactAssessment.ruleTopic.split(',') : this.ruleTopicDD;
  // }

  ddListData(): void {
    this.searchedResponseLead = this.impactAssessmentDD.responseLead;
    this.searchedAccountableExecutive = this.impactAssessmentDD.accountableExecutive;
    this.searchedTopic = this.impactAssessmentDD.ruleTopics;

    this.allSearchedResponseLead = this.impactAssessmentDD.responseLead;
    this.allSearchedAccountableExecutive = this.impactAssessmentDD.accountableExecutive;
    this.allSearchedTopic = this.impactAssessmentDD.ruleTopics;

    this.searchResponseLeadCntrl.valueChanges.subscribe((term: any) => {
      this.searchedResponseLead = term ? this.filterResponseLead(term) : this.impactAssessmentDD.responseLead;
    });
    this.searchAccountableExecutiveCntrl.valueChanges.subscribe((term: any) => {
      this.searchedAccountableExecutive = term ? this.filterAccountableExecutive(term) : this.impactAssessmentDD.accountableExecutive;
    });
    this.searchTopicCntrl.valueChanges.subscribe((term: any) => {
      this.searchedTopic = term ? this.filterTopic(term) : this.impactAssessmentDD.ruleTopics;
    });
  }
  getImpactAssesmentDropdownList(jurisdiction: string): void {
    this.impactService.getImpactAssesmentT5DropDownList(jurisdiction).subscribe((result: ImpactAssessmentT5DropDownList) => {
      result.team.forEach(element => {
        this.team.push(element.title)
      });
      result.ragRating.forEach(element => this.ragRating = JSON.parse(element.title));

      result.currentStatus.forEach(element => {
        this.currentStatus.push(element.title)
      });
      result.responseApproach.forEach(element => {
        this.responseApproach.push(element.title)
      });
      result.engagementPlan.forEach(element => {
        this.engagementPlan.push(element.title)
      });
      result.policyResponseAchieved.forEach(element => {
        this.policyResponseAchieved.push(element.title)
      });
      result.ruleType.forEach(element => {
        this.ruleType.push(element.title)
      });
    });
  }
  //ResponseLead
  addResponseLead(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.responseLeadAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.responseLeadDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.responseLeadDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchResponseLeadCntrl.setValue(null);
    }
  }
  selectedResponseLeadEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.responseLeadDD) {
      let sameValueRow = this.responseLeadDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.responseLeadDD.push(event.option.viewValue);
      }
    } else {
      this.responseLeadDD = [];
      this.responseLeadDD.push(event.option.viewValue);
    }
    if (this.responseLeadInput) {
      this.responseLeadInput.nativeElement.value = '';
    }
    this.searchResponseLeadCntrl.setValue(null);
    this.searchResponseLeadCntrl.disable();
    this.searchResponseLeadCntrl.enable();
    // this.updateSectionLastEdited('Assessor');
  }
  removeResponseLead(status: string): void {
    const index = (this.responseLeadDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.responseLeadDD as string[]).splice(index, 1);
      // this.updateSectionLastEdited('Assessor');
    }
  }
  filterResponseLead(search: string): any {
    return this.searchedResponseLead.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  //AccountableExecutive
  addAccountableExecutive(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.accountableExecutiveAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.accountableExecutiveDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.accountableExecutiveDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchAccountableExecutiveCntrl.setValue(null);
      // this.updateSectionLastEdited('Assessor');
    }
  }
  selectedAccountableExecutiveEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.accountableExecutiveDD) {
      let sameValueRow = this.accountableExecutiveDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.accountableExecutiveDD.push(event.option.viewValue);
      }
    } else {
      this.accountableExecutiveDD = [];
      this.accountableExecutiveDD.push(event.option.viewValue);
    }
    if (this.accountableExecutiveInput) {
      this.accountableExecutiveInput.nativeElement.value = '';
    }
    this.searchAccountableExecutiveCntrl.setValue(null);
    this.searchAccountableExecutiveCntrl.disable();
    this.searchAccountableExecutiveCntrl.enable();
    // this.updateSectionLastEdited('Assessor');
  }
  removeAccountableExecutive(status: string): void {
    const index = (this.accountableExecutiveDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.accountableExecutiveDD as string[]).splice(index, 1);
      // this.updateSectionLastEdited('Assessor');
    }
  }
  filterAccountableExecutive(search: string): any {
    return this.searchedAccountableExecutive.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  //Rule Topic
  addTopic(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.topicAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.ruleTopicDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.ruleTopicDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchTopicCntrl.setValue(null);
    }
  }
  selectedTopicEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.ruleTopicDD) {
      let sameValueRow = this.ruleTopicDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.ruleTopicDD.push(event.option.viewValue);
      }
    } else {
      this.ruleTopicDD = [];
      this.ruleTopicDD.push(event.option.viewValue);
    }
    if (this.topicInput) {
      this.topicInput.nativeElement.value = '';
    }
    this.searchTopicCntrl.setValue(null);
    this.searchTopicCntrl.disable();
    this.searchTopicCntrl.enable();
  }
  removeTopic(status: string): void {
    const index = (this.ruleTopicDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.ruleTopicDD as string[]).splice(index, 1);
    }
  }
  filterTopic(search: string): any {
    return this.searchedTopic.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  updateSectionLastEdited(){
    if (this.impactAssessment.resposeDeadline && this.impactAssessment.updatedDB_Date) {
      const updatedDBDate = new Date(this.impactAssessment.updatedDB_Date);
      const differenceMs = this.impactAssessment.resposeDeadline.getTime() - updatedDBDate.getTime();
      const differenceWeeks = differenceMs / (1000 * 60 * 60 * 24 * 7);
      const roundedWeeks = Math.round(differenceWeeks);
      this.impactAssessment.consultationPeriod = roundedWeeks + " Weeks";
    }
    else {
      this.impactAssessment.consultationPeriod = "";
    }
    this.ref.detectChanges();
  }
  getFilteredData(filter: string, event: any): void {
    this.searchStr += event.key;
    switch (filter) {
      case 'ResponseLead':
        const searchedRL = Array<FilterViewModel>();
        if (this.searchedResponseLead.length > 0) {
          this.searchedResponseLead.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedRL.push(element);
            }
          });
          this.searchedResponseLead = searchedRL;
        } else {
          this.searchedResponseLead = this.allSearchedResponseLead;
        }
        break;
      case 'AccountableExecutive':
        const searchedAE = Array<FilterViewModel>();
        if (this.searchedAccountableExecutive.length > 0) {
          this.searchedAccountableExecutive.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedAE.push(element);
            }
          });
          this.searchedAccountableExecutive = searchedAE;
        } else {
          this.searchedAccountableExecutive = this.allSearchedAccountableExecutive;
        }
        break;
      case 'RuleTopic':
        const searchedRT = Array<FilterViewModel>();
        if (this.searchedTopic.length > 0) {
          this.searchedTopic.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedRT.push(element);
            }
          });
          this.searchedTopic = searchedRT;
        } else {
          this.searchedTopic = this.allSearchedTopic;
        }
        break;
    }
    this.searchStr = '';
  }
  updateImpactAssessment(): void {
    this.impactAssessment.accountableExecutive = this.accountableExecutiveDD.toString();
    this.impactAssessment.responseLead = this.responseLeadDD.toString();
    this.impactAssessment.ruleTopic = this.ruleTopicDD.toString();
    //Have to to for Topic also

    //Date Fields
    this.impactAssessment.resposeDeadline = this.impactAssessment.resposeDeadline ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.resposeDeadline.toString()) : null;
    this.impactAssessment.effectiveDate = this.impactAssessment.effectiveDate ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.effectiveDate.toString()) : null;
    this.impactAssessment.responseSubmissionDate = this.impactAssessment.responseSubmissionDate ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.responseSubmissionDate.toString()) : null;
    this.impactAssessment.nextActionDate = this.impactAssessment.nextActionDate ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.nextActionDate.toString()) : null;

    this.impactAssessment.userId = this.userAccessToken.externalUserId;
    this.impactAssessment.userName = this.userAccessToken.fullName;
    const currentUrl = window.location.href;
    this.impactAssessment.lastUpdatedTime = MasterHelper.getDate(0);
    this.updateIADetails.impactAssessment = this.impactAssessment;
    this.dialogRef.close(this.impactAssessment);
  }
  getBackgroundColor(itemTitle: string): string {
    const selectedOption = this.ragRating.find(option => option.itemTitle === itemTitle);
    return selectedOption ? selectedOption.color : '';
  }
}
